import { Link } from "react-router-dom";
import { ArrowRight, Building2 } from "lucide-react";
import { useSEO } from "@/hooks/useSEO";
import { useContent } from "@/context/ContentContext";
import { Reveal } from "@/components/Reveal";
import { IMAGES } from "@/data/siteData";

const About = () => {
  useSEO({
    title: "Om os | AA+PLUS MILJØSANERING – Byggefirma i Randers",
    description: "AA+PLUS MILJØSANERING er en dansk bygge- og entreprenørvirksomhed med base i Randers, ejet af Nicu-Alexandru Minca.",
  });
  const { content } = useContent();
  const c = content?.contact || {};

  return (
    <div data-testid="about-page">
      <section className="bg-[#1F2937] py-20 lg:py-28">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <span className="text-[#FF5A00] font-semibold text-sm uppercase tracking-widest">Om os</span>
          <h1 className="mt-3 text-4xl sm:text-5xl font-extrabold tracking-tight text-white max-w-3xl">En pålidelig bygge- og entreprenørvirksomhed i Randers</h1>
        </div>
      </section>

      <section className="py-16 lg:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-14 items-start">
          <Reveal>
            <div className="space-y-5 text-lg text-gray-600 leading-relaxed">
              <p>
                AA+PLUS MILJØSANERING er en dansk bygge- og entreprenørvirksomhed med base i Randers. Virksomheden ejes og drives af Nicu-Alexandru Minca.
              </p>
              <p>
                Vi udfører konstruktionsarbejde, nedrivning, renovering og øvrige byggepladsrelaterede opgaver for danske erhvervskunder. Vores mål er at være en fleksibel og pålidelig samarbejdspartner, der leverer det aftalte arbejde på en professionel og dokumenterbar måde.
              </p>
            </div>
            <div className="mt-8 overflow-hidden rounded-sm border border-gray-200">
              <img src={IMAGES.facade} alt="Bygning under renovering i Danmark" className="w-full h-72 object-cover" />
            </div>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="bg-gray-50 border border-gray-200 rounded-sm p-8 lg:p-10" data-testid="company-info-box">
              <div className="flex items-center gap-3 mb-6">
                <Building2 className="text-[#FF5A00]" size={26} />
                <h2 className="text-xl font-bold text-gray-900">Virksomhedsoplysninger</h2>
              </div>
              <dl className="space-y-4 text-gray-700">
                <div><dt className="text-xs uppercase tracking-wider text-gray-500">Virksomhed</dt><dd className="font-semibold">{c.company_name}</dd></div>
                <div><dt className="text-xs uppercase tracking-wider text-gray-500">CVR</dt><dd className="font-semibold">{c.cvr}</dd></div>
                <div><dt className="text-xs uppercase tracking-wider text-gray-500">Adresse</dt><dd className="font-semibold">{c.address}<br />{c.postal_city}</dd></div>
                <div><dt className="text-xs uppercase tracking-wider text-gray-500">Land</dt><dd className="font-semibold">{c.country}</dd></div>
                <div><dt className="text-xs uppercase tracking-wider text-gray-500">Ejer</dt><dd className="font-semibold">Nicu-Alexandru Minca</dd></div>
              </dl>
              <Link to="/kontakt" data-testid="about-cta-btn" className="mt-8 inline-flex items-center gap-2 bg-[#FF5A00] text-white font-semibold px-6 py-3 rounded-sm hover:bg-[#E04F00] transition-colors w-full justify-center">
                Kontakt os <ArrowRight size={18} />
              </Link>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
};

export default About;
